import { c as _c } from "react/compiler-runtime";
import { Banner } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { useTranslation } from 'react-i18next';
export type SandboxBannerHandler = {
  getHeight: () => number;
};
type SandboxBannerProps = {
  hideOnDesktop?: boolean;
};
const SandboxBanner = forwardRef<SandboxBannerHandler, SandboxBannerProps>((t0, ref) => {
  const $ = _c(12);
  const {
    hideOnDesktop
  } = t0;
  const containerRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => containerRef.current?.clientHeight ?? 0;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const getHeight = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "global.components.layout"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    t
  } = useTranslation("idv", t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => ({
      getHeight
    });
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  useImperativeHandle(ref, t3);
  const t4 = hideOnDesktop && "md:hidden";
  let t5;
  if ($[3] !== t4) {
    t5 = cx("border-b border-solid border-tertiary z-[5]", t4);
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t) {
    t6 = t(_temp);
    $[5] = t;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t6) {
    t7 = <Banner variant="warning">{t6}</Banner>;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t5 || $[10] !== t7) {
    t8 = <div ref={containerRef} className={t5} data-testid="sandbox-banner">{t7}</div>;
    $[9] = t5;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
});
export default SandboxBanner;
function _temp($) {
  return $["sandbox-banner"];
}